import React from 'react';
import SiteNavbar from './SiteNavbar';
import SiteFooter from './SiteFooter';

type SiteLayoutProps = {
  children: React.ReactNode;
};

function SiteLayout({ children }: SiteLayoutProps) {
  return (
    <div className="d-flex flex-column min-vh-100 bg-secondary-soft">
      <SiteNavbar />
      <main className="flex-grow-1">{children}</main>
      <SiteFooter />
    </div>
  );
}

export default SiteLayout;
